import { useEffect, useState } from 'react'
import grooveAPI from 'api/groove'

// Keep successes and failures across layout remounts, scoped to the signed-in
// account and user. A new browser session starts with an empty in-memory cache.
const requests = new Map()

function statusForSession(scope) {
  if (!requests.has(scope)) {
    const request = Promise.resolve()
      .then(() => grooveAPI.send('GET', null, 'v1/helply_migration/status', {}))
      .then(response => (response.success ? response.json : null))
      .catch(() => null)
    requests.set(scope, request)
  }
  return requests.get(scope)
}

export default function useLinkStatus(scope, enabled) {
  const [snapshot, setSnapshot] = useState(null)
  useEffect(
    () => {
      if (!enabled) return undefined
      let active = true
      statusForSession(scope).then(status => {
        if (active) setSnapshot({ scope, status })
      })
      return () => {
        active = false
      }
    },
    [scope, enabled]
  )
  return enabled && snapshot?.scope === scope ? snapshot.status : null
}
